import { render, staticRenderFns } from "./ead-curso-cadastro.vue?vue&type=template&id=ccdb9dfe&scoped=true&"
import script from "./ead-curso-cadastro.vue?vue&type=script&lang=js&"
export * from "./ead-curso-cadastro.vue?vue&type=script&lang=js&"
import style0 from "./ead-curso-cadastro.vue?vue&type=style&index=0&id=ccdb9dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdb9dfe",
  null
  
)

export default component.exports